import { Form } from "react-bootstrap";

const FechaSelector = ({
  fecha,
  setFecha,
  f_inicio,
  f_termino,
  formatToISO,
  disabled = false,
}) => (
  <Form.Group className="asistencia-curso-form">
    <Form.Label>Fecha</Form.Label>
    <Form.Control
      type="date"
      value={fecha}
      onChange={(e) => setFecha(e.target.value)}
      min={formatToISO(f_inicio)}
      max={formatToISO(f_termino)}
      disabled={disabled}
    />
  </Form.Group>
);
export default FechaSelector;
